// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ProviderService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Provider';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

const useProviderServices: () => UseQueryResult<
  TemplateContract<ProviderService>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  return useQueryWithOptions({
    queryKey: ['queryRegistryProviderServices', operator],
    enabled: !!operator,
    queryFn: async (_, options) => {
      return ledgerApi.queryRegistryProviderServices(options, operator);
    },
  });
};

export default useProviderServices;
